import { render, staticRenderFns } from "./QuestionnaireGroupsList.vue?vue&type=template&id=ac9a4a64&scoped=true"
import script from "./QuestionnaireGroupsList.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireGroupsList.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireGroupsList.vue?vue&type=style&index=0&id=ac9a4a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9a4a64",
  null
  
)

export default component.exports